import { Routes, Route } from "react-router-dom";
import TagList from "./TagList";
import TagForm from "./TagForm";

export default function Tag() {
  return (
    <div style={{ padding: "30px" }}>
      <h2>Tags</h2>

      <Routes>
        <Route path="/" element={<TagList />} />
        <Route path="new" element={<TagForm />} />
        <Route path="edit/:id" element={<TagForm />} />
      </Routes>
    </div>
  );
}
